import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import originalImage from '../../../assets/wan_original_image.png';
import imageGeneratedVideo from '../../../assets/video/wan_image_generate_video.mp4';
import textGeneratedVideo from '../../../assets/video/wan_text_generate_video.mp4';
import './Examples.scss';

export default function Examples() {
  const { t } = useI18n();
  return (
    <section className="wan-examples">
      <div className="wan-examples__inner">
        <h2>{t('videoGeneration.wan.examples.title')}</h2>
        <p className="wan-examples__sub">{t('videoGeneration.wan.examples.sub')}</p>

        <div className="wan-examples__grid">
          <div className="wan-example-card">
            <div className="wan-example-card__title">{t('videoGeneration.wan.examples.imageToVideoTitle')}</div>
            <p className="wan-example-card__desc">{t('videoGeneration.wan.examples.imageToVideoDesc')}</p>
            <div className="wan-example-inner">
              <div className="wan-example-section">{t('videoGeneration.wan.examples.sectionLabel')}</div>
              <div className="wan-example-stack">
                <div className="wan-v-box">
                  <img src={originalImage} alt="original" className="wan-v-img" />
                </div>
                <div className="wan-v-box">
                  <video className="wan-v-video" src={imageGeneratedVideo} controls muted playsInline preload="metadata" poster={originalImage} />
                </div>
              </div>
            </div>
          </div>

          <div className="wan-example-card">
            <div className="wan-example-card__title">{t('videoGeneration.wan.examples.textToVideoTitle')}</div>
            <p className="wan-example-card__desc">{t('videoGeneration.wan.examples.textToVideoDesc')}</p>
            <div className="wan-example-inner">
              <div className="wan-example-section">{t('videoGeneration.wan.examples.sectionLabel')}</div>
              <div className="wan-example-prompt">
                {t('videoGeneration.wan.examples.promptText')}
              </div>
              <div className="wan-example-stack">
                <div className="wan-v-box">
                  <video className="wan-v-video" src={textGeneratedVideo} controls muted playsInline preload="metadata" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}